module.exports = __webpack_public_path__ + "img/mobiledropdown.82e06ae0.gif";